import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

/**
 * Full-screen premium cross-fade that fires every time the Apple/Android
 * platform switches. Picks up the new --brand-accent-soft automatically,
 * so Apple ↔ Android reads as an ambient colour wipe.
 */
const PlatformFlipOverlay = () => {
  const [key, setKey] = useState(0);
  const [platform, setPlatform] = useState(typeof document !== "undefined"
    ? document.body.getAttribute("data-platform") || "apple"
    : "apple");

  useEffect(() => {
    const h = (e) => {
      setPlatform(e.detail);
      setKey((k) => k + 1); // force re-mount so the animation replays
    };
    window.addEventListener("tracksy:platform", h);
    return () => window.removeEventListener("tracksy:platform", h);
  }, []);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={key}
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[9999]"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 0.6, 0] }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8, times: [0, 0.45, 1], ease: [0.22, 1, 0.36, 1] }}
        style={{
          background: `radial-gradient(circle at 50% 25%, var(--brand-accent-soft) 0%, transparent 60%),
                       linear-gradient(135deg, var(--brand-accent-soft) 0%, transparent 65%)`,
        }}
        data-testid={`platform-flip-${platform}`}
      />
    </AnimatePresence>
  );
};

export default PlatformFlipOverlay;
